import type { ReactElement } from 'react';

import { initiatorMark, initiatorTitle, type InitiatorBy } from '../lib/initiator';

/**
 * Значок инициатора слева от блока «имя + кэф», вне потока: имя, лого и кэф
 * стоят там же, где без метки. Силуэт — копия аватарки сайта: заливка,
 * рукоять сверху, четыре зубца вниз. Цифры нет. Вторая нога с count молчит.
 */
function ForkMark(): ReactElement {
  return (
    <svg viewBox="0 0 32 70" aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        d="M12.7.3h6.6c.45 0 .65.3.65 1C19.5 8.2 20.6 13.4 24.8 17.8 29.1 22.4 31.6 26.2 31.75 32.2 31.9 43.6 31.3 56.4 29.8 65.8 29.4 68.2 28.4 69.5 27.2 69.55H4.8C3.6 69.5 2.6 68.2 2.2 65.8.7 56.4.1 43.6.25 32.2.4 26.2 2.9 22.4 7.2 17.8 11.4 13.4 12.5 8.2 12.65 1.3c0-.7.2-1 .05-1zM8 36.8c1.15 0 1.6 1.15 1.7 2.7L10.6 72H5.4l.9-32.5c.1-1.55.55-2.7 1.7-2.7zm8 0c1.15 0 1.6 1.15 1.7 2.7L18.6 72h-5.2l.9-32.5c.1-1.55.55-2.7 1.7-2.7zm8 0c1.15 0 1.6 1.15 1.7 2.7L26.6 72h-5.2l.9-32.5c.1-1.55.55-2.7 1.7-2.7z"
      />
    </svg>
  );
}

export function InitiatorDot({
  initiator,
  initiatorCount,
  by,
  className = 'nx-fk__ini',
}: {
  initiator?: boolean;
  initiatorCount?: number | null;
  by?: InitiatorBy | string | null;
  className?: string;
}): ReactElement | null {
  const mark = initiatorMark({ initiator, initiatorCount }, by);
  if (mark.kind === 'none' || mark.kind === 'empty') return null;
  return (
    <span
      className={`${className} ${className}--on${mark.by === 'mirror' ? ` ${className}--mirror` : ''}`}
      title={initiatorTitle(mark)}
    >
      <ForkMark />
    </span>
  );
}
